import { default as Home } from 'components/layouts/home'
import { default as Events, EventCalendar } from 'components/layouts/events'
import { default as Blog, BlogFeed, BlogPost } from 'components/layouts/blog'
import { default as Ecosystem, EntityDetails } from 'components/layouts/ecosystem'
import { NotFound, Authors, Contact, NewsletterPanel } from 'components/layouts/generic'

export default [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { label: 'SPK' },
    children: [
      {
        path: 'collaborateurs',
        name: 'authors',
        component: Authors
      },
      {
        path: 'contact',
        name: 'contact',
        component: Contact
      },
      {
        path: 'infolettre',
        name: 'newsletter',
        component: NewsletterPanel
      }
    ]
  },
  {
    path: '/ecosysteme',
    name: 'ecosystem',
    component: Ecosystem,
    meta: { label: 'Écosystème' },
    children: [
      {
        path: ':entity',
        name: 'ecosystem-entity',
        component: EntityDetails,
        props: true
      }
    ]
  },
  {
    path: '/blogue',
    component: Blog,
    meta: { label: 'Blogue' },
    children: [
      {
        path: '',
        name: 'blog',
        component: BlogFeed
      },
      {
        path: 'page/:paging',
        name: 'blog-page',
        component: BlogFeed,
        props: true
      },
      {
        path: 'categorie/:cat',
        name: 'blog-category',
        component: BlogFeed,
        props: true
      },
      {
        path: 'categorie/:category/page/:paging',
        name: 'blog-category-page',
        component: BlogFeed,
        props: true
      },
      {
        path: ':uid',
        name: 'blog-post',
        components: { default: BlogFeed, post: BlogPost },
        props: { default: true, post: true }
      }
    ]
  },
  {
    path: '/evenements',
    component: Events,
    meta: { label: 'Événements' },
    children: [
      {
        path: '',
        name: 'events',
        component: EventCalendar
      },
      {
        path: 'page/:paging',
        name: 'events-page',
        component: EventCalendar,
        props: true
      }
    ]
  },
  {
    path: '*',
    name: 'not-found',
    component: NotFound,
    meta: { hidden: true }
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js